import { render, staticRenderFns } from "./TabUnitDelivery.vue?vue&type=template&id=43284a4a&"
import script from "./TabUnitDelivery.vue?vue&type=script&lang=ts&"
export * from "./TabUnitDelivery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43284a4a')) {
      api.createRecord('43284a4a', component.options)
    } else {
      api.reload('43284a4a', component.options)
    }
    module.hot.accept("./TabUnitDelivery.vue?vue&type=template&id=43284a4a&", function () {
      api.rerender('43284a4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DailyOperationalReport/TabUnitDelivery.vue"
export default component.exports